import { Injectable } from '@angular/core';
import { getIconPathByHostname } from '../constant/constant-function';
import { NXTRIAL_IDENTIFIER, MERILLIFE_IDENTIFIER, NXTRIAL_SPINNER_CLASS, MERIL_SPINNER_CLASS } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class LogoService {

  constructor() { }

  getFaviconPath(): string {

    return getIconPathByHostname(
      'assets/icons/NX.png',
      'assets/Images/merillogo.jpeg',
      'assets/icons/favicon.jpg'
    );
  }

   getLogoPath(): string {
    // For localhost testing: check port number
    // return getIconPathByPort(
    //   'assets/Images/Media.png',
    //   'assets/Images/merillogo.jpeg',
    //   'assets/icons/yourlogohere.png'
    // );

    return getIconPathByHostname(
      'assets/Images/Media.png',
      'assets/Images/merillogo.jpeg',
      'assets/icons/yourlogohere.png'
    );
  }

  getSpinnerLogoPath(): string {
    return getIconPathByHostname(
      'assets/icons/NX.png',
      'assets/Images/merillogo.jpeg',
      'assets/icons/favicon.jpg'
    );
  }

  getSpinnerClass(): string {
    // For production: check hostname
    const currentUrl = window.location.hostname;
    if (currentUrl.includes(NXTRIAL_IDENTIFIER)) {
      return NXTRIAL_SPINNER_CLASS;
    } else if (currentUrl.includes(MERILLIFE_IDENTIFIER)) {
      return MERIL_SPINNER_CLASS;
    }

    // Default spinner class
    return NXTRIAL_SPINNER_CLASS;
  }
}
